import { takeEvery, takeLatest } from 'redux-saga/effects';
import GatewaysContainerConstants from '~/components/containers/GatewaysContainer/constants';
import callRequestSaga from '~/sagas/utils/request-saga';
import GatewaysAPI from '~/api/gateways-api';

export function* getGateways() {
  yield* callRequestSaga(GatewaysAPI.getGateways, {
    request: GatewaysContainerConstants.GET_GATEWAYS_REQUEST,
    success: GatewaysContainerConstants.GET_GATEWAYS_REQUEST_SUCCESS,
    failure: GatewaysContainerConstants.GET_GATEWAYS_REQUEST_ERROR,
  });
}

export function* removeGateway({ gatewayId }) {
  yield* callRequestSaga(
    GatewaysAPI.removeGateway,
    {
      request: GatewaysContainerConstants.REMOVE_GATEWAY_REQUEST,
      success: GatewaysContainerConstants.REMOVE_GATEWAY_REQUEST_SUCCESS,
      failure: GatewaysContainerConstants.REMOVE_GATEWAY_REQUEST_ERROR,
      payload: {
        gatewayId,
      },
    },
    gatewayId
  );
}

export function* getGatewaysSaga() {
  yield takeLatest(GatewaysContainerConstants.GET_GATEWAYS, getGateways);
}

export function* removeGatewaySaga() {
  // @ts-ignore
  yield takeEvery(GatewaysContainerConstants.REMOVE_GATEWAY, removeGateway);
}

export default [getGatewaysSaga, removeGatewaySaga];
